import React, { useState } from 'react'
import PhoneInput from 'react-phone-input-2'

import TwofaInput from '@components/TwofaInput'
import { InputField } from '@components/FormBuilder'
import Fetch from '@javascript/Fetch'
import Icon from '@components/shared/icons'
import { formatPhoneNumber } from '@javascript/util'

import Envelope from '@images/svg/envelope-check.svg'

import 'react-phone-input-2/lib/material.css'

const Login = ({ data }) => {
  const { requestTwofaPath, confirmTwofaPath, reaPath } = data

  const [view, setView] = useState('phone')
  const [phone, setPhone] = useState('')
  const [email, setEmail] = useState('')
  const [dialCode, setDialCode] = useState('')
  const [phoneError, setPhoneError] = useState([])
  const [twofaError, setTwofaError] = useState([])
  const [pin, setPin] = useState('')
  const [twofaType, setTwofaType] = useState('phone')

  const handlePhoneChange = (newPhone, data, e, formattedValue) => {
    setPhone(newPhone);
    setDialCode(data.dialCode);
    setPhoneError([]);
  }

  const onEnterKeyPress = (e) => {
    if (e.key === "Enter") {
      sendTwofa(e);
    }
  }

  const handleEmailChange = (e) => {
    setEmail(e.currentTarget.value)
  }

  const handleChangePin = (e, value) => {
    setPin(value)
  }

  const retry = () => {
    setView(twofaType);
    setPhoneError([]);
    setTwofaError([]);
  }

  const redirectBackToRea = () => {
    window.open(reaPath, '_self')
  }

  const sendTwofa = async (e) => {
    const target = e.currentTarget

    target.disabled = true

    setTwofaType(view)

    const payload = view === 'phone' ? { phone } : { email }

    const resp = await Fetch.post({
      url: requestTwofaPath,
      payload,
    })

    if (!resp.errors) {
      setView('confirmation')
    } else {
      setPhoneError([resp.errors])
    }

    target.disabled = false
  }

  const confirmTwofa = async (e) => {
    const target = e.currentTarget

    target.disabled = true

    const resp = await Fetch.post({
      url: confirmTwofaPath,
      payload: {
        code: pin,
        phone,
        email,
      },
    })

    if (!resp.errors) {
      window.location = resp.url
    } else {
      setTwofaError(resp.errors)
    }

    target.disabled = false
  }

  const swapView = (newView) => {
    setPhoneError([]);
    setView(newView)
  }

  const twofaContent = () => {
    switch (view) {
      case 'email':
        return (
          <div className="twofa-inputs">
            <p className="gray-500">
              In order to retrieve your agents, we need you to verify your
              contact information.
            </p>
            <InputField
              id="email"
              label=""
              klass="full"
              value={email}
              placeholder="Email"
              handleChange={handleEmailChange}
              onKeyDown={onEnterKeyPress}
              error={phoneError}
            />
            <button
              type="button"
              className="edit-button large-bold-font"
              onClick={sendTwofa}
            >
              Email Access Code
            </button>
            <div className="or-divider" />
            <button
              type="button"
              className="edit-button plain large-bold-font"
              onClick={swapView.bind(null, 'phone')}
            >
              <Icon type="phone" />
              Verify with phone
            </button>
          </div>
        )
      case 'confirmation':
        return (
          <div className="twofa-inputs">
            <TwofaInput
              pinLength={6}
              onChange={handleChangePin}
              error={twofaError.length > 0}
              setError={setTwofaError}
              confirmTwofa={confirmTwofa}
            />
            <p className="large-slim-font gray-500 text-align-center">
              A message with a verification code was just sent to&nbsp;
              <b>{twofaType === 'phone' ? formatPhoneNumber(phone) : email }</b>
            </p>
            <button
              type="button"
              className="edit-button large-bold-font"
              onClick={confirmTwofa}
            >
              Continue to Agents List
            </button>
            <div className="update-cell large-slim-font gray-500 margin-bottom-24">
              <div className="update-cell-prompt">
                Didn&apos;t receive a code?
              </div>
              <div className="update-cell-actions">
                <button
                  type="button"
                  className="update-cell-button large-bold-font"
                  onClick={retry}
                >
                  Try another method
                </button>
                or
                <button
                  type="button"
                  className="update-cell-button large-bold-font"
                  onClick={redirectBackToRea}
                >
                  create a new request
                </button>
              </div>
            </div>
          </div>
        )
      default:
        return (
          <div className="twofa-inputs">
            <p className="gray-500">
              In order to retrieve your agents, we need you to verify your
              contact information.
            </p>
            <div className="phone-wrapper">
              <PhoneInput
                value={phone}
                preferredCountries={['ca', 'us']}
                country="us"
                disableCountryGuess
                enableSearch={true}
                countryCodeEditable={false}
                specialLabel={false}
                onChange={handlePhoneChange}
                onEnterKeyPress={onEnterKeyPress}
                inputProps={{
                  required: true,
                  autoComplete: 'tel-national',
                  pattern: parseInt(dialCode, 10) === 1 ? '.{17,}' : '.{10,}',
                  minLength: parseInt(dialCode, 10) === 1 ? 17 : 10,
                  'data-error': phoneError.length > 0,
                }}
              />
              {phoneError.length > 0 && (
                <span className="small-bold-font">{phoneError}</span>
              )}
            </div>
            <button
              type="button"
              className="edit-button large-bold-font"
              onClick={sendTwofa}
            >
              Text Access Code
            </button>
            <div className="or-divider" />
            <button
              type="button"
              className="edit-button plain large-bold-font"
              onClick={swapView.bind(null, 'email')}
            >
              <Icon type="mail" />
              Verify with email
            </button>
          </div>
        )
    }
  }

  return (
    <div className="page-container">
      <div className="login-wrapper">
        <div className="login">
          <h1>
            Find And Compare
            <br />
            The Best Local Realtors!
          </h1>
          <div className="login-screen form-builder">
            <img src={Envelope} alt="envelope" />
            <h2>Welcome Back!</h2>
            {twofaContent()}
            {view !== 'confirmation' && (
              <div className="login-footer">
                We&apos;ll send you an access code allowing you to view your
                agents. Choose either email or text message (standard message
                rates apply) to receive your access code.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login
